export default __webpack_public_path__ + "83d4180cc222a87b7dcccb4b95b9627f.png";